import { ExternalNetworkContract } from '@terra/shared-contracts-external-network';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'orchestrator';

export const externalNetworkClient = createTerraOrpcClient({
  contract: ExternalNetworkContract,
  serviceName: SERVICE_NAME,
});
